import * as i0 from '@angular/core';
import { Pipe, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule, DecimalPipe } from '@angular/common';
import * as i1$1 from '@angular/platform-browser';

class DecimalNumberPipe {
    transform(value) {
        if (!value) {
            return null;
        }
        return parseFloat(value.toString().replace(/,/g, ''));
    }
}
DecimalNumberPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DecimalNumberPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
DecimalNumberPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DecimalNumberPipe, name: "decimalNumber" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DecimalNumberPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'decimalNumber'
                }]
        }] });

class DecimalNumberPipeModule {
}
DecimalNumberPipeModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DecimalNumberPipeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DecimalNumberPipeModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DecimalNumberPipeModule, declarations: [DecimalNumberPipe], imports: [CommonModule], exports: [DecimalNumberPipe] });
DecimalNumberPipeModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DecimalNumberPipeModule, providers: [DecimalPipe], imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DecimalNumberPipeModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DecimalNumberPipe],
                    imports: [CommonModule],
                    providers: [DecimalPipe],
                    exports: [DecimalNumberPipe]
                }]
        }] });

class DecimalStringPipe {
    constructor(_decimalPipe) {
        this._decimalPipe = _decimalPipe;
    }
    transform(value) {
        if (!value) {
            return null;
        }
        return this._decimalPipe.transform(parseFloat(value.toString().replace(/,/g, '')), '1.0-0');
    }
}
DecimalStringPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DecimalStringPipe, deps: [{ token: i1.DecimalPipe }], target: i0.ɵɵFactoryTarget.Pipe });
DecimalStringPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DecimalStringPipe, name: "decimalString" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DecimalStringPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'decimalString'
                }]
        }], ctorParameters: function () { return [{ type: i1.DecimalPipe }]; } });

class DecimalStringPipeModule {
}
DecimalStringPipeModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DecimalStringPipeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DecimalStringPipeModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DecimalStringPipeModule, declarations: [DecimalStringPipe], imports: [CommonModule], exports: [DecimalStringPipe] });
DecimalStringPipeModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DecimalStringPipeModule, providers: [DecimalPipe], imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DecimalStringPipeModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DecimalStringPipe],
                    imports: [CommonModule],
                    exports: [DecimalStringPipe],
                    providers: [DecimalPipe]
                }]
        }] });

class SafeSrcPipe {
    constructor(sanitized) {
        this.sanitized = sanitized;
    }
    transform(value) {
        return this.sanitized.bypassSecurityTrustResourceUrl(value);
    }
}
SafeSrcPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: SafeSrcPipe, deps: [{ token: i1$1.DomSanitizer }], target: i0.ɵɵFactoryTarget.Pipe });
SafeSrcPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: SafeSrcPipe, name: "safeSrc" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: SafeSrcPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'safeSrc'
                }]
        }], ctorParameters: function () { return [{ type: i1$1.DomSanitizer }]; } });

class SafeSrcPipeModule {
}
SafeSrcPipeModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: SafeSrcPipeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SafeSrcPipeModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: SafeSrcPipeModule, declarations: [SafeSrcPipe], imports: [CommonModule], exports: [SafeSrcPipe] });
SafeSrcPipeModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: SafeSrcPipeModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: SafeSrcPipeModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SafeSrcPipe],
                    imports: [CommonModule],
                    exports: [SafeSrcPipe]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { DecimalNumberPipe, DecimalNumberPipeModule, DecimalStringPipe, DecimalStringPipeModule, SafeSrcPipe, SafeSrcPipeModule };
